import Column from 'layout/Components/Column'
import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import OpenEffect from 'UIKit/OpenEffect'
import { PAYMENT_MODAL_THEME } from 'views/Payment/MobilePayment/components/styles'
import SwapForm from 'views/Payment/MobilePayment/Swap/components/SwapForm'

interface SwapProps {
  onDismiss: () => void
}

const Swap: React.FC<SwapProps> = () => {
  return (
    <>
      <ModalHeader hideStroke titleAlign="left" colorTheme={PAYMENT_MODAL_THEME} title="Swap" />
      <ModalBody>
        <OpenEffect openType="grow" duration={0.4}>
          <Column height="100%">
            <SwapForm />
          </Column>
        </OpenEffect>
      </ModalBody>
    </>
  )
}

export default Swap
